<div *ngIf="canShow" class="d-flex flex-column p-1">
    <div class="title mb-0 pb-0">-{{title}}-</div>
    <div [ngClass]="big ? 'fw-bold' : ''" class="value mt-0 pt-0">{{value}}</div>
</div>
